import {
  type CreateCompanyFormValues,
  getAmadeusLinkField,
  parseLegalIdentifier,
} from "./create-company-schema";

/**
 * Turns the wizard values into the API payload. Two shapes, one form:
 * with a parent company we create a `TravelAgencyCompanySubAccount` (only GDS name + thirdId
 * number matter there), otherwise a full `TravelAgencyCompany` with its legal entity.
 */
export function buildCreateCompanyPayload(values: CreateCompanyFormValues) {
  if (values.parentCompanyId) {
    return {
      mode: "subAccount",
      subAccount: {
        mainAccountId: values.parentCompanyId,
        rawGdsName: values.displayName,
        thirdId: linkFieldOf(values) === "thirdId" ? values.amadeusLink : null,
        accountManagerId: values.accountManagerId,
        teamId: values.teamId,
      },
    } as const;
  }

  return {
    mode: "company",
    company: {
      ...(parseLegalIdentifier(values.identifier) ?? {}),
      tenantId: values.tenantId,
      domain: values.domain,
      displayName: values.displayName,
      additionalDomains: values.additionalDomains.length ? values.additionalDomains : null,
      bluebizIdentifier: values.bluebizIdentifier || null,
      mainContactEmail: values.mainContactEmail || null,
      accountManagerId: values.accountManagerId,
      teamId: values.teamId,
      thirdId: linkFieldOf(values) === "thirdId" ? values.amadeusLink : null,
      rawGdsName: linkFieldOf(values) === "rawGdsName" ? values.amadeusLink : null,
    },
  } as const;
}

function linkFieldOf(values: CreateCompanyFormValues) {
  return values.amadeusLinkType ? getAmadeusLinkField(values.amadeusLinkType) : null;
}
